import { Card, Col, Row, Typography } from "antd";
import { Star } from "lucide-react";

const { Title, Paragraph, Text } = Typography;

const testimonials = [
  {
    name: "Jessica Martinez",
    business: "Luxe Hair Studio, Miami",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces",
    quote:
      "I was skeptical at first, but Hairplane paid for itself in the first week. We're booking 40% more appointments and I've gotten 15 hours of my life back every week. My only regret is not switching sooner.",
    metric: "$4,200 more revenue per month",
  },
  {
    name: "Michael Rodriguez",
    business: "The Barber's Guild, Austin",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=faces",
    quote:
      "Game changer. The automated reminders alone cut our no-shows by 90%. Plus my staff loves seeing their commissions in real-time. Best investment I've made in 10 years of business.",
    metric: "90% fewer no-shows",
  },
  {
    name: "Sarah Kim",
    business: "Bloom Collective, San Francisco",
    image:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=faces",
    quote:
      "Running 3 locations used to be a nightmare. Now I manage everything from my phone. The reports show me exactly what's working and what's not. It's like having a business consultant 24/7.",
    metric: "Manages 3 locations effortlessly",
  },
];

export function TestimonialsSection() {
  return (
    <section id="reviews" className="landing-section landing-testimonials">
      <Title level={2}>Don't Take Our Word For It</Title>
      <Paragraph className="landing-section-subtitle">
        See why salon and barbershop owners are switching to Hairplane.
      </Paragraph>

      <Row gutter={[24, 24]}>
        {testimonials.map((testimonial) => (
          <Col xs={24} md={8} key={testimonial.name}>
            <Card className="testimonial-card">
              <div className="testimonial-stars">
                {Array.from({ length: 5 }).map((_, index) => (
                  <Star key={index} size={18} fill="currentColor" />
                ))}
              </div>

              <Paragraph>“{testimonial.quote}”</Paragraph>

              <div className="testimonial-author">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="testimonial-avatar"
                />
                <div>
                  <Text strong>{testimonial.name}</Text>
                  <br />
                  <Text type="secondary">{testimonial.business}</Text>
                </div>
              </div>

              <div className="testimonial-metric">{testimonial.metric}</div>
            </Card>
          </Col>
        ))}
      </Row>
    </section>
  );
}
